import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/lists/templates/")({
  beforeLoad: () => {
    throw redirect({ to: "/lists", search: { tab: "templates" }, replace: true });
  },
});
